/**
 * Re-export the auth hook & provider from the canonical AuthContext.
 *
 * Every module should import from 'hooks/useAuth' instead of
 * reaching into 'context/AuthContext' directly — this keeps the
 * import path short and makes a future migration painless.
 */
export { useAuth, AuthProvider } from 'context/AuthContext';
